import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { DialogTitle, styled, Typography, IconButton } from '@mui/material';
import { forwardRef } from 'react';
import '../Icons/Add.js';
import '../Icons/Application.js';
import '../Icons/AppStore.js';
import '../Icons/Arrow.js';
import '../Icons/At.js';
import '../Icons/Attach.js';
import '../Icons/Bank.js';
import '../Icons/Battery.js';
import '../Icons/Bell.js';
import '../Icons/Blocked.js';
import '../Icons/Calendar.js';
import '../Icons/Card.js';
import '../Icons/CaretDown.js';
import '../Icons/CaretLeft.js';
import '../Icons/CaretRight.js';
import '../Icons/CaretUp.js';
import '../Icons/Checkbox.js';
import '../Icons/CheckboxChecked.js';
import '../Icons/CheckboxIndeterminate.js';
import '../Icons/ChevronLeft.js';
import '../Icons/ChevronRight.js';
import '../Icons/Company.js';
import '../Icons/Copy.js';
import '../Icons/Currency.js';
import '../Icons/Customers.js';
import '../Icons/Dash.js';
import '../Icons/Dashboard.js';
import '../Icons/DirectionDown.js';
import '../Icons/DirectionUp.js';
import '../Icons/Document.js';
import '../Icons/DoubleChevronLeft.js';
import '../Icons/DoubleChevronRight.js';
import '../Icons/DoubleDirectionDown.js';
import '../Icons/DoubleDirectionUp.js';
import '../Icons/Download.js';
import '../Icons/Edit.js';
import '../Icons/ExclamationMark.js';
import '../Icons/ExclamationMarkFilled.js';
import '../Icons/ExternalLink.js';
import '../Icons/EyeClosed.js';
import '../Icons/EyeOpen.js';
import '../Icons/Fingerprint.js';
import '../Icons/Folder.js';
import '../Icons/Forever.js';
import '../Icons/Funnel.js';
import '../Icons/GooglePlay.js';
import '../Icons/Iban.js';
import '../Icons/Id.js';
import '../Icons/Info.js';
import '../Icons/InfoFilled.js';
import '../Icons/Instant.js';
import '../Icons/Ip.js';
import '../Icons/Link.js';
import '../Icons/List.js';
import '../Icons/Mail.js';
import '../Icons/Menu.js';
import '../Icons/Message.js';
import '../Icons/MessageDot.js';
import '../Icons/Onboarding.js';
import '../Icons/Padlock.js';
import '../Icons/PadlockOpen.js';
import '../Icons/Percent.js';
import '../Icons/Play.js';
import '../Icons/PowerOff.js';
import '../Icons/ProcessCompleted.js';
import '../Icons/ProcessCountEight.js';
import '../Icons/ProcessCountFive.js';
import '../Icons/ProcessCountFour.js';
import '../Icons/ProcessCountNineAndMore.js';
import '../Icons/ProcessCountOne.js';
import '../Icons/ProcessCountSeven.js';
import '../Icons/ProcessCountSix.js';
import '../Icons/ProcessCountThree.js';
import '../Icons/ProcessCountTwo.js';
import '../Icons/ProcessFailed.js';
import '../Icons/ProcessInProgress.js';
import '../Icons/ProcessNotStarted.js';
import '../Icons/ProcessPartialInProgress.js';
import '../Icons/ProcessPaused.js';
import '../Icons/Profile.js';
import '../Icons/Progress.js';
import '../Icons/Provider.js';
import '../Icons/QuestionMark.js';
import '../Icons/QuestionMarkFilled.js';
import Remove from '../Icons/Remove.js';
import '../Icons/Repeat.js';
import '../Icons/Reset.js';
import '../Icons/RoundArrow.js';
import '../Icons/RoundArrowFilled.js';
import '../Icons/RoundCheckOutlined.js';
import '../Icons/RoundCheckOutlinedFilled.js';
import '../Icons/RoundClose.js';
import '../Icons/RoundCloseFilled.js';
import '../Icons/RoundLeft.js';
import '../Icons/RoundLeftFilled.js';
import '../Icons/RoundMinus.js';
import '../Icons/RoundMinusFilled.js';
import '../Icons/RoundPlus.js';
import '../Icons/RoundPlusFilled.js';
import '../Icons/RoundRight.js';
import '../Icons/RoundRightFilled.js';
import '../Icons/Settings.js';
import '../Icons/SettingsCog.js';
import '../Icons/Shield.js';
import '../Icons/StarFilled.js';
import '../Icons/StarOutlined.js';
import '../Icons/Success.js';
import '../Icons/Timer.js';
import '../Icons/Trash.js';
import '../Icons/Upload.js';
import '../Icons/User.js';
import '../Icons/VerticalDots.js';
import '../Icons/World.js';
import '../Icons/Wrench.js';
import '../Icons/Zoom.js';

const Title = forwardRef(function DialogTitle$1(_a, ref) {
    var { onClose, children, disableTypography, typographyProps } = _a, rest = __rest(_a, ["onClose", "children", "disableTypography", "typographyProps"]);
    return (jsxs(DialogTitle, Object.assign({}, rest, { ref: ref, children: [disableTypography ? (children) : (jsx(TitleTypography, Object.assign({ variant: "h5" }, typographyProps, { children: children }))), onClose && (jsx(RemoveIconButton, { "aria-label": "close", onClick: onClose, children: jsx(Remove, {}) }))] })));
});
const TitleTypography = styled(Typography)({
    gridColumn: 2,
    justifySelf: "center",
    alignSelf: "center",
    textAlign: "center",
});
const RemoveIconButton = styled(IconButton)({
    width: 28,
    height: 28,
    marginRight: 8,
    gridColumn: 3,
    justifySelf: "end",
    alignSelf: "center",
});

export { Title };
//# sourceMappingURL=DialogTitle.js.map
